import React from "react";
import { ButtonGroup, Input, Select } from "controls";
import { capitalizedFirst, DropLi } from "hooks";
import { useUpdateDateRange } from "hooks/useUpdateDateRange";
import { periodMap } from "constants/datePeriods";

const SpecifyPeriod = ({ values, setValues, errors }) => {
  const { TimePeriods } = DropLi();

  const handleInpChg = (e) => {
    setValues((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // Hook updates values.fromDate and values.toDate automatically
  useUpdateDateRange(values, setValues);

  return (
    <div className="flex flex-col gap-5">
      <ButtonGroup
        name="timePeriod"
        value={values.timePeriod}
        onChange={handleInpChg}
        options={TimePeriods}
      />

      <Select
        name="timeRange"
        value={values?.timeRange}
        onChange={handleInpChg}
        options={[
          {
            id: 1,
            label: `${capitalizedFirst(periodMap[values?.timePeriod])} to date`,
          },
          {
            id: 2,
            label: `Previous ${periodMap[values?.timePeriod]}`,
          },
          {
            id: 3,
            label: `Choose previous ${periodMap[values?.timePeriod]}`,
          },
        ]}
      />

      {values?.timeRange === 3 && (
        <Input
          label={`Number of ${periodMap[values?.timePeriod]}`}
          name="numberOfPeriod"
          value={values.numberOfPeriod}
          error={errors.numberOfPeriod}
          type="number"
          required={true}
          onChange={handleInpChg}
          onBlur={(e) => {
            if (!e.target.value || Number(e.target.value) <= 0)
              handleInpChg({
                target: { name: "numberOfPeriod", value: 0 },
              });
          }}
        />
      )}
    </div>
  );
};

export default SpecifyPeriod;
